import { useLayoutEffect } from 'react';
import { useAppDispatch } from 'src/AppContext';
import useCustomHistory from 'src/hooks/useCustomHistory';
import { isKorean } from 'src/services/util';
import dayjs from 'dayjs';

type Props = {
  item: NoticeItem;
};

export default function NoticeDetail({ item }: Props): JSX.Element {
  const dispatch = useAppDispatch();
  const history = useCustomHistory();
  // const [item, setItem] = useState({} as any);

  useLayoutEffect(() => {
    dispatch({ type: 'SET_GNB_LEFT', name: 'hidden' });
    dispatch({ type: 'SET_GNB_RIGHT', name: 'close' });
    dispatch({
      type: 'SET_GNB_RIGHT_CALLBACK',
      cb: () => {
        history.goBack();
      },
    });
    return () => {
      dispatch({ type: 'RESET_GNB_LEFT' });
      dispatch({ type: 'RESET_GNB_RIGHT' });
      dispatch({ type: 'RESET_GNB_RIGHT_CALLBACK' });
    };
  }, []);

  // useEffect(() => {
  //   const id = props.match.params.id;
  //   setItem(NOTICE.find((item) => item.id.toString() === id));
  // }, [props.match.params.id]);

  return (
    <div className="container pb-10">
      <div className="mt-6 N_16_R">{item[isKorean() ? 'koTitle' : 'enTitle']}</div>
      <div className="mt-2 N_12_R text-brown-grey mb-6">{dayjs(item.updateDate).format('YYYY.MM.DD HH.mm')}</div>
      {/* <div className="mt-6">{item.image && <img src={item.image} className="object-cover w-full" />}</div> */}
      {/* <div className={'N_14_R text-greyish-brown ' + (item.image ? 'mt-6' : 'mt-10')}>{item.content}</div> */}
      {item.koImage && item.enImage && <img className="w-full object-contain mb-2" src={item[isKorean() ? 'koImage' : 'enImage']} />}
      <div className={'N_14_R text-greyish-brown pt-4'}>{item[isKorean() ? 'koContent' : 'enContent']}</div>
    </div>
  );
}
